import ElakayImage from '../../components/images/ElakayImage';
import React from "react";
import { MdDeleteForever, MdDesktopWindows, MdPhoneIphone } from "react-icons/md";
// import "./Userpubgallery.css";
import "./PubGallery.css";
import imgLakay from '../Layout/imgs/Untitled-2.jpg';
import { elakayAutoText } from "./dataElakay";
import { getElakayImageLoadUrl } from "../../config";


let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["userpubgallery"]?.[key] || fallback;

const getHardcodedText = (infoSource, group, key, fallback) =>
  infoSource?.laguangeElakay?.("frontElakayHardcodedText", infoSource.languageAPI)?.[group]?.[key] || fallback;

/**
 * ===== USER PUB GALLERY =====
 * Gallery for user publication images
 * - Follow images
 * - Category images
 * - Admin view images
 * - Follow view images
 * - Slider shop images
 */

const UserPubGallery = ({
toImageUrl,
  getUserPub,
  infoSource,
  refObjName,
  deleteimgPubFonc
}) => {
  __setElakayInfoSource(infoSource);
  const text = (key, fallback) => getHardcodedText(infoSource, "userpubgallery", key, fallback);

  // Render PubImgFollow
  const renderPubImgFollow = () => {
    if (!getUserPub?.PubImgFollow?.urlImg) return null;

    return (
      <div className="pub-section">
        <div className="pub-section-header">
          <h3 className="pub-section-title">{refObjName?.[1] || elakayAutoText("h_61388658790228", "Follow Images")}</h3>
        </div>
        
        <div className="pub-gallery-grid pub-grid-simple">
          <div className="pub-card">
            <div className="pub-image-wrapper">
              <ElakayImage preset="banner"
                className="pub-image"
                src={getElakayImageLoadUrl(toImageUrl(getUserPub?.PubImgFollow?.urlImg), { width: 600 })}
                loading="lazy"
                decoding="async"
                alt={refObjName?.[1]}
              />
              
              <div className="pub-overlay">
                <button
                  className="pub-overlay-btn pub-btn-delete"
                  onClick={() => deleteimgPubFonc(1, getUserPub?.PubImgFollow?.urlImg)}
                  title={text("t001", "Delete")}
                >
                  <MdDeleteForever />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Render PubCategory
  const renderPubCategory = () => {
    if (!getUserPub?.PubCategory || getUserPub?.PubCategory?.length === 0) return null;

    return (
      <div className="pub-section">
        <div className="pub-section-header">
          <h3 className="pub-section-title">{refObjName?.[2] || elakayAutoText("h_310e98a27be024", "Category Images")}</h3>
          <span className="pub-section-badge">{getUserPub?.PubCategory?.length}{__elakayText("t017", "images")}</span>
        </div>

        <div className="pub-gallery-grid">
          {getUserPub?.PubCategory?.map((p, i) => (
            <div key={i} className="pub-card">
              <div className="pub-image-wrapper">
                <ElakayImage preset="banner"
                  className="pub-image"
                  src={getElakayImageLoadUrl(toImageUrl(p.urlImg), { width: 300 })}
                  loading="lazy"
                  decoding="async"
                  alt={`${refObjName?.[2]}: ${i}`}
                />
                
                <div className="pub-overlay">
                  <button
                    className="pub-overlay-btn pub-btn-delete"
                    onClick={() => deleteimgPubFonc(2, p.urlImg)}
                    title={text("t002", "Delete")}
                  >
                    <MdDeleteForever />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  // Render ImagAdmin
  const renderImagAdmin = () => {
    if (!getUserPub?.viewImagAdmin?.urlImg) return null;

    return (
      <div className="pub-section">
        <div className="pub-section-header">
          <h3 className="pub-section-title">{refObjName?.[3] || elakayAutoText("h_1412258b1f8106", "Admin View Images")}</h3>
        </div>

        <div className="pub-gallery-grid pub-grid-banner">
          <div className="pub-card">
            <div className="pub-image-wrapper">
              <ElakayImage preset="banner"
                className="pub-image"
                src={getElakayImageLoadUrl(toImageUrl(getUserPub.viewImagAdmin.urlImg), { width: 600 })}
                loading="lazy"
                decoding="async"
                alt={text("t003", "Admin Desktop")}
              />
              
              <div className="pub-overlay">
                <button
                  className="pub-overlay-btn pub-btn-delete"
                  onClick={() => deleteimgPubFonc(3, getUserPub.viewImagAdmin.urlImg)}
                  title={text("t004", "Delete")}
                >
                  <MdDeleteForever />
                </button>
              </div>

              <div className="pub-device-label pub-device-desktop">
                <MdDesktopWindows />
                <span>{text("t005", "Desktop & Tablet")}</span>
                <span className="pub-dimension-badge">{text("t006", "1200x500")}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Render ImagForFollow
  const renderImagForFollow = () => {
    if (!getUserPub?.viewImagforFollow?.urlImg) return null;

    return (
      <div className="pub-section">
        <div className="pub-section-header">
          <h3 className="pub-section-title">{refObjName?.[4] || elakayAutoText("h_785fb70b6f06c9", "Follow View Images")}</h3>
        </div>

        <div className="pub-gallery-grid pub-grid-banner">
          <div className="pub-card">
            <div className="pub-image-wrapper">
              <ElakayImage preset="banner"
                className="pub-image"
                src={getElakayImageLoadUrl(toImageUrl(getUserPub.viewImagforFollow.urlImg), { width: 600 })}
                loading="lazy"
                decoding="async"
                alt={text("t007", "Follow Desktop")}
              />
              
              <div className="pub-overlay">
                <button
                  className="pub-overlay-btn pub-btn-delete"
                  onClick={() => deleteimgPubFonc(4, getUserPub.viewImagforFollow.urlImg)}
                  title={text("t008", "Delete")}
                >
                  <MdDeleteForever />
                </button>
              </div>

              <div className="pub-device-label pub-device-desktop">
                <MdDesktopWindows />
                <span>{text("t009", "Desktop & Tablet")}</span>
                <span className="pub-dimension-badge">{text("t010", "1200x500")}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Render SliderShop
  const renderSliderShop = () => {
    if (!getUserPub?.sliderShop || getUserPub.sliderShop.length === 0) return null;

    return (
      <div className="pub-section">
        <div className="pub-section-header">
          <h3 className="pub-section-title">{refObjName?.[5] || elakayAutoText("h_3ac43094f13995", "Shop Slider")}</h3>
          <span className="pub-section-badge">{getUserPub.sliderShop.length}{__elakayText("t017", "images")}</span>
        </div>

        <div className="pub-gallery-grid">
          {getUserPub.sliderShop.map((p, i) => (
            <div key={i} className="pub-card">
              {/* Desktop Preview */}
              <div className="pub-image-wrapper">
                <ElakayImage preset="banner"
                  className="pub-image"
                  src={getElakayImageLoadUrl(toImageUrl(p.urlImg), { width: 600 })}
                  loading="lazy"
                  decoding="async"
                  onError={(e) => {
                    e.target.src = imgLakay;
                    e.onerror = null;
                  }}
                  alt={p.user}
                />

                {/* Overlay Controls */}
                <div className="pub-overlay">
                  <button
                    className="pub-overlay-btn pub-btn-delete"
                    onClick={() => deleteimgPubFonc(5, p.urlImg)}
                    title={text("t011", "Delete")}
                  >
                    <MdDeleteForever />
                  </button>
                </div>

                {/* Device Label */}
                <div className="pub-device-label pub-device-desktop">
                  <MdDesktopWindows />
                  <span>{text("t012", "Desktop/Tablet")}</span>
                  <span className="pub-dimension-badge">{text("t013", "1200x500")}</span>
                </div>
              </div>

              {/* Mobile Preview */}
              <div className="pub-image-wrapper pub-mobile-preview">
                <ElakayImage preset="banner"
                  className="pub-image"
                  src={getElakayImageLoadUrl(toImageUrl(p.urlImg), { width: 300 })}
                  loading="lazy"
                  decoding="async"
                  onError={(e) => {
                    e.target.src = imgLakay;
                    e.onerror = null;
                  }}
                  alt={p.user}
                />

                {/* Overlay Controls */}
                <div className="pub-overlay">
                  <button
                    className="pub-overlay-btn pub-btn-delete"
                    onClick={() => deleteimgPubFonc(5, p.urlImg)}
                    title={text("t014", "Delete")}
                  >
                    <MdDeleteForever />
                  </button>
                </div>

                {/* Device Label */}
                <div className="pub-device-label pub-device-mobile">
                  <MdPhoneIphone />
                  <span>{text("t015", "Mobile")}</span>
                  <span className="pub-dimension-badge">{text("t016", "800x500")}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  // Main render
  return (
    <div className="pub-gallery-container">
      {renderPubImgFollow()}
      {renderPubCategory()}
      {renderImagAdmin()}
      {renderImagForFollow()}
      {renderSliderShop()}
    </div>
  );
};

export default UserPubGallery;
